import { render } from "./Payments.vue?vue&type=template&id=481eba0d&ts=true"
import script from "./Payments.vue?vue&type=script&lang=ts"
export * from "./Payments.vue?vue&type=script&lang=ts"

import "./Payments.vue?vue&type=style&index=0&id=481eba0d&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__